var _path, _circle, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoVerify({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3026 19.5027L22.4292 18.6294L16.6765 24.3821V25.2555H17.5498L23.3026 19.5027ZM24.1759 18.6294L25.0493 17.756L24.1759 16.8827L23.3026 17.756L24.1759 18.6294ZM18.0612 26.4908H15.4412V23.8701L23.7393 15.572C23.8551 15.4562 24.0121 15.3912 24.1759 15.3912C24.3397 15.3912 24.4968 15.4562 24.6126 15.572L26.3599 17.3193C26.4757 17.4352 26.5408 17.5922 26.5408 17.756C26.5408 17.9198 26.4757 18.0769 26.3599 18.1927L18.0612 26.4908Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "url(#paint0_linear_82_1400)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "url(#paint1_linear_82_1400)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_82_1400)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6945 33.1111C30.4531 33.1111 33.5 30.0642 33.5 26.3056C33.5 22.547 30.4531 19.5 26.6945 19.5C22.9359 19.5 19.8889 22.547 19.8889 26.3056C19.8889 30.0642 22.9359 33.1111 26.6945 33.1111ZM28.1373 27.1916L29.8396 28.894C30.0733 29.1277 30.0733 29.5065 29.8397 29.7403C29.7227 29.857 29.5697 29.9152 29.4164 29.9152C29.2634 29.9152 29.1102 29.857 28.9933 29.7403L27.3113 28.0582C26.8269 28.3958 26.2381 28.5945 25.6025 28.5945C23.9501 28.5945 22.6107 27.2553 22.6107 25.6028C22.6107 23.9504 23.9502 22.6111 25.6025 22.6111C27.2548 22.6111 28.5944 23.9504 28.5944 25.6028C28.5944 26.1869 28.4265 26.7311 28.1373 27.1916ZM23.5802 25.603C23.5802 26.7199 24.4857 27.6253 25.6025 27.6253C26.7194 27.6253 27.6248 26.7199 27.6248 25.603C27.6248 24.4861 26.7194 23.5806 25.6025 23.5806C24.4857 23.5806 23.5802 24.4861 23.5802 25.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4768 10.9444H20.3836C20.0556 9.82639 19.0022 9 17.7499 9C16.4977 9 15.4443 9.82639 15.1163 10.9444H14.0231C13.6156 10.9444 13.2777 11.275 13.2777 11.6736V13.1319C13.2777 14.0653 14.0628 14.8333 15.0169 14.8333H20.483C21.437 14.8333 22.2222 14.0653 22.2222 13.1319V11.6736C22.2222 11.275 21.8843 10.9444 21.4768 10.9444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6691 11.7222H23.4118V13.0185C23.4118 14.5948 22.1456 15.8704 20.5809 15.8704H14.9191C13.3544 15.8704 12.0882 14.5948 12.0882 13.0185V11.7222H11.8309C10.2662 11.7222 9 12.9978 9 14.5741V27.537C9 29.1133 10.2662 30.3889 11.8309 30.3889H18.6147C18.1 29.2793 17.7912 28.0556 17.7603 26.7593H12.8603C12.4382 26.7593 12.0882 26.4067 12.0882 25.9815C12.0882 25.5563 12.4382 25.2037 12.8603 25.2037H17.8426C17.9353 24.5711 18.0897 23.9696 18.2956 23.3889H12.8603C12.4382 23.3889 12.0882 23.0363 12.0882 22.6111C12.0882 22.1859 12.4382 21.8333 12.8603 21.8333H19.0368C19.4382 21.1696 19.9118 20.5578 20.4676 20.0185H12.8603C12.4382 20.0185 12.0882 19.6659 12.0882 19.2407C12.0882 18.8156 12.4382 18.463 12.8603 18.463H22.5779C23.7618 17.8407 25.0897 17.4674 26.5 17.4363V14.5741C26.5 12.9978 25.2338 11.7222 23.6691 11.7222Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_82_1400",
    x: 6.94118,
    y: 9,
    width: 28.6177,
    height: 28.2287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.05882
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.02941
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_82_1400"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_82_1400",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_82_1400",
    x1: 20.2799,
    y1: 41.9993,
    x2: 20.2799,
    y2: -0.20532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8856"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_82_1400",
    x1: 20.2799,
    y1: 41.9993,
    x2: 20.2799,
    y2: -8.43876e-9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB4B03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#F16722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776219,
    stopColor: "#FB8856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC4AA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVerify);
export default __webpack_public_path__ + "static/media/ico-verify.26a9673ddfc2c3f52632846554d3c129.svg";
export { ForwardRef as ReactComponent };